export default __webpack_public_path__ + "static/media/caricon.7fc7da92.png";